// UserContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import {
  fetchUserDetails,
  removeCheckoutClientInfo,
  removeTokens,
} from "../services/authService";
import {
  getMyFavouritesByType,
  getUserStatsObject,
  recordActivity,
} from "../services/commonService";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [my_favourites, setFavourites] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const userInfo = await fetchUserDetails();

        if (userInfo) {
          await setMyAllFavourites();
        }
        const accessToken =
          localStorage.getItem("access_token") ||
          sessionStorage.getItem("access_token");
        if (accessToken) {
          window.__chatbot?.setAuth?.({
            Authorization: `Bearer ${accessToken}`,
          });
        }
        setUser(userInfo);
      } catch (error) {
        console.error("Error fetching user details:", error);
        removeTokens(); // Clear invalid tokens
        setUser(null);  // Ensure user state is null for redirect
      } finally {
        setLoading(false); // Enable rendering after check
      }
    };

    getUserInfo();
  }, []);

  const handleLogout = (redirectUrl = "/login") => {
    let userStat = getUserStatsObject(
      "Logout",
      "login",
      "Logout",
      window.location.href,
      ""
    );
    userStat.url_details = { page: window.location.href };
    recordActivity(userStat);

    try {
      window.__chatbot?.setAuth?.({});
      window.__chatbot?.destroy?.();
    } catch { }

    setTimeout(() => {
      removeCheckoutClientInfo();
      removeTokens();
      // window.location.replace(redirectUrl);
      window.location.replace("/login");
    }, 1000);
  };

  const setUserRole = (role, role_key) => {
    setUser((prevUser) => ({ ...prevUser, role, role_key }));
  };

  const setMyAllFavourites = async () => {
    const favourites = await getMyFavouritesByType("all");
    setFavourites(favourites);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        handleLogout,
        setUserRole,
        my_favourites,
        setMyAllFavourites,
        loading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
